/** 
*@author: satyamurthy.a
*@Description : 
**/
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { GETUSERLIST } from "../../../commons/api";
import { Form, Input, Button, message } from "antd";
import localStorage from "../../../utils/localStorage";
import LayoutAction from "../../../modules/actions/LayoutAction";
import themeSettings from '../../../commons/styles/themeSettings.json';

const EditProfileComponent = (props) => {
  const { userProfile, translationCache, LayoutAction } = props;
  const [profile, setProfile] = useState(userProfile);
  const editProfileRef = useRef();

  useEffect(() => {
    editProfileRef.current.setFieldsValue(
      userProfile && userProfile.user ? userProfile.user : {}
    );
    setProfile(userProfile);
  }, [userProfile]);

  const updateProfile = (data) => {
    const siteId = localStorage.get("currentSite");
    const accessToken = localStorage.get("accessToken");
    const changePassword = {
      method: "PATCH",
      url: `${GETUSERLIST.UPDATE}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data
    };
    axios(changePassword)
      .then((response) => {
        message.success(translation(response.data.message));
        LayoutAction.getLoggedInProfile();
      })
      .catch((error) => {
        message.error(`${error && error.response && error.response.data && error.response.data.message ?
          error.response.data.message :
          "Error"
        }`);
      });
  };

  const translation = (keyword) => {
    return translationCache && translationCache[keyword]
      ? translationCache[keyword]
      : keyword;
  };

  const onFinish = (values) => {
    updateProfile({ ...profile.user, ...values });
  };

  const onFinishFailed = () => {
    message.error(
      translation("Please enter valid FirstName and LastName")
    );
  };

  return (
    <Form
      theme={themeSettings}
      ref={editProfileRef}
      name="basic"
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item
        label={translation("First Name")}
        name="FirstName"
        rules={[
          {
            required: true,
            message: [translation("Please input your FirstName!!")],
          },
        ]}
      >
        <Input style={{ width: "300px" }} />
      </Form.Item>

      <Form.Item
        label={translation("Last Name")}
        name="LastName"
        rules={[
          {
            required: true,
            message: [translation("Please input your LastName!")],
          },
        ]}
      >
        <Input style={{ width: "300px" }} />
      </Form.Item>
      <Form.Item
        label={translation("Email")}
        name="Email"
        rules={[
          {
            required: true,
            message: [translation("Please input your Email!")],
          },
        ]}
      >
        <Input style={{ width: "300px" }} disabled />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit">
          {translation("Update Profile")}
        </Button>
      </Form.Item>
    </Form>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    LayoutAction: bindActionCreators(LayoutAction, dispatch)
  };
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EditProfileComponent);